import * as React from 'react';

import { Link } from 'react-router-dom';
import { Box, Button, Image, Label } from '@moosend/mooskin';
import { PermissionsCheck } from './PermissionsAndLimitsContext';
import { PermissionsEnum } from '../../../../accounts/src/services/model';

export interface IEmptyPage {
	src: string;
	title: string;
	route?: string;
	label?: string;
	onClick?: () => void;
	className?: string;
	style?: React.CSSProperties;
	permissions?: PermissionsEnum[];
}

export const EmptyPage: React.FC<IEmptyPage> = (props) => {
	return (
		<Box
			className={props.className}
			style={props.style}
			d="flex"
			align="center"
			justify="center"
			direction="column"
			noRender={['sm', 'xs']}
		>
			<Image w="100%" maxW={400} src={props.src} />
			<Label my={30} fontColor="fontColors.medgray1" fontSize={20} textTransform="capitalize">
				{props.title}
			</Label>
			<PermissionsCheck requiredPermissions={props.permissions ?? []} mode="no-render">
				{props.route ? (
					<Link to={props.route} onClick={props.onClick}>
						{props.label && <Button>{props.label}</Button>}
					</Link>
				) : (
					props.label && <Button onClick={props.onClick}>{props.label}</Button>
				)}
			</PermissionsCheck>
		</Box>
	);
};
